import { render, staticRenderFns } from "./ruleInfo.vue?vue&type=template&id=5ca64b93&scoped=true&"
import script from "./ruleInfo.vue?vue&type=script&lang=js&"
export * from "./ruleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ruleInfo.vue?vue&type=style&index=0&id=5ca64b93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca64b93",
  null
  
)

export default component.exports